export const getAvgRating = (reviews = []) => {
  const reviewsSum = reviews.reduce((acc, curr) => {
    const rating = curr?.attributes?.rating || 0;

    return acc + rating;
  }, 0);

  return reviewsSum;
};
